import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import makeAnimated from 'react-select/animated';
import { addLanguage } from 'slices/languageSlice';
import { updateLanguage } from 'slices/languageSlice';
import { fetchLanguages } from 'slices/languageSlice';
import toast from 'react-hot-toast';
import { languageSelector } from 'slices/languageSlice';
import { setError } from 'slices/languageSlice';
import { CustomSwitch } from 'components/common/Switch';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import { useTranslation } from 'react-i18next';

const AddLanguageForm = ({ item, handleClose, callback, statusPerm }) => {
  const { t } = useTranslation();
  const animatedComponents = makeAnimated();
  const dispatch = useDispatch();
  const [formValues, setFormValues] = useState({
    name: '',
    status: 1
  })
  const { error, loader } = useSelector(languageSelector);


  useEffect(() => {
    if (item?.id)
      setFormValues({
        name: item?.name || "",
        status: item?.status
      })

    return () => {
      dispatch(setError({}))
      setFormValues({
        ...formValues,
        name: "",
        status: 1
      });
      // Clean up on unmount
      // This is where you would dispatch an action to remove the hospital from the store
    }

  }, [item])

  const handleChange = (e) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  }

  const submitCallback = (status, message) => {
    if (status) {
      callback()
      toast.success(message, {
        className: "successToast",
      })
      dispatch(fetchLanguages())
      handleClose()
    }
    else {
      console.log('onSubmit', error)
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Handle form submission
    dispatch(setError({}))
    if (item?.id) {
      dispatch(updateLanguage(formValues, item?.id, submitCallback));
    } else
      dispatch(addLanguage(formValues, submitCallback));

  }


  return (
    <div>
      <form onSubmit={handleSubmit}>

        <div className="row-primary">
          <h2>{t('languageForm.nameLabel')}</h2>
          <input onChange={handleChange}
            required name="name"
            className="input-in type_inp"
            type="text"
            placeholder={t('languageForm.namePlaceholder')}
            value={formValues.name}
          />
        </div>

        {statusPerm &&
          <div className="row-primary flex-row align-items-center" style={{ alignItems: "center" }}>
            <h2 className='mt-0'>{t('table.status')}</h2>
            <CustomSwitch
              labelText="active"
              checked={formValues.status == 1 ? true : false}
              handleChange={(checked) => setFormValues({
                ...formValues,
                status: checked ? 1 : 0
              })}
            />
          </div>
        }


        {error?.errors?.name?.map((error) => (
          <div style={{ marginBottom: 10 }}>
            <ErrorMessage text={error} />
          </div>
        ))}


        <div className="Form-footer">
          <button type="button" className="Cancle_button" onClick={handleClose}>{t('common.cancel')}</button>
          <SubmitButton
            btnText={item?.id ? t('common.update') : t('common.create')}
            loader={loader}
          />
        </div>
      </form>

    </div>
  )
}

const AddLanguage = ({ item, show, onClose, callback ,statusPerm }) => {
  const { t } = useTranslation();
  if (!show) return null;
  return (
    <>
    <div className={`modal fade show`} style={{ display: 'block' }} id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" role="dialog">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content full_modal">
          <div className="modal-header header_modal align-items-center">
            <div></div>
            <h5 className="modal-title_u">{item?.id ? t('common.update') : t('common.create')} {t('languageForm.title')}</h5>
            <button onClick={onClose} type="button" className="btn-close" aria-label="Close"></button>
          </div>
          <div className="modal-body modal_form_body">
            <AddLanguageForm item={item} handleClose={onClose} callback={callback} statusPerm={statusPerm}/>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show"></div>
    </>
  )
}

export default AddLanguage
